import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import PublicPage from 'components/PublicPages/PublicPage';

const {
  public_font_size_md: publicFontSizeMd,
  public_app_max_width: publicAppMaxWidth,
  custom_blue: customBlue,
} = variables;

export const BlogPage = styled(PublicPage)``;

export const MobileWrapper = styled('div')``;

export const TagWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
`;

export const BlogPostShare = styled('div')`
  position: fixed;
  pointer-events: none;
  left: 0;
  right: 0;
  margin: 0 auto 0;
  padding-top: 102px;
  top: 30px;
  max-width: 1000px !important;
  width: 100% !important;
  button {
    pointer-events: all;
    display: block;
    svg {
      circle {
        fill: rgba(0, 56, 132, 0.38);
        transition: all 0.3s ease;
      }
      &:hover {
        circle {
          fill: ${customBlue};
        }
      }
    }
  }
  &.mobile {
    display: none;
  }
  @media (max-width: 1045px) {
    max-width: 870px !important;
  }
  @media (max-width: 900px) {
    &.desktop {
      display: none;
    }
    &.mobile {
      display: block;
    }
    position: relative;
    top: auto;
    max-width: 790px !important;
    width: 100%;
    padding: 0px 20px 20px;
    left: auto;
    right: auto;
    button {
      display: inline-block;
      margin: 10px 7px 0px 0 !important;
      svg circle {
        fill: ${customBlue};
      }
    }
  }
  @media (max-width: 700px) {
    margin: 10px 3px 0px !important;
    button {
      margin: 10px 15px 0px 0 !important;
    }
  }
`;

export const BlogPostTemplatePage = styled('div')`
  .mega-draft-editor-wrapper {
    padding: 0px 20px 0 !important;
  }
  @media (max-width: 700px) {
    padding: 10px 10px 0 !important;
  }
  @media (max-width: 500px) {
    padding: 0px !important;
  }
`;

export const RelatedBlogPostsWrapper = styled('div')`
  padding: 60px 40px 20px;
  max-width: ${publicAppMaxWidth};
  margin: 0 auto;
`;

export const Oval = styled.div`
  display: inline-block;

  margin: 0 10px 0 0;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  border: 2px solid #b0bed1;
`;

export const List = styled.ul`
  margin-left: 40px;
  list-style-type: none;

  li {
    margin-bottom: 16px;
  }

  p {
    font-size: ${publicFontSizeMd};
    line-height: 32px;
    display: inline;
    padding: 8px 0;
  }
`;

export const GlobalWarehouseBottomBanner = styled('div')`
  max-width: ${publicAppMaxWidth};
  padding: 20px 0;
  margin: 0 auto 40px;
  display: flex;
  flex-flow: column;
  align-items: center;
  #globalWarehouseBanner {
    margin-bottom: 30px;
  }
`;
